import { useMutation, useQuery, useQueryClient, UseQueryOptions } from '@tanstack/react-query';
import { SynchronizationService } from 'services/synchronization/synchronization.service';
import { SyncDocumentHistory } from 'services/synchronization/synchronization.type';
type UsesSynchronizeHistoryOptions = Omit<UseQueryOptions<any[]>, 'queryKey'> & {
  connection_id?: string;
  site?: string;
};
const useSynchronizeHistory = ({
  connection_id = '',
  site = '',
  ...options
}: UsesSynchronizeHistoryOptions = {}) => {
  const query = useQuery<SyncDocumentHistory[]>({
    queryKey: ['synchronizeHistory'],
    queryFn: () => SynchronizationService.syncDocumentHistories({ connection_id, site }),
    ...options,
  });
  return query;
};

export const useDeleteSyncHistory = () => {
  const client = useQueryClient();
  return useMutation({
    mutationFn: SynchronizationService.deleteSyncHistory,
    onSettled: () => client.invalidateQueries({ queryKey: ['synchronizeHistory'] }),
  });
};

export default useSynchronizeHistory;
